import { Suspense, lazy } from 'react';
import { RouteObject } from 'react-router';

const Snapshot = lazy(() => import('./Snapshot'));

const DEBUG_ROUTES: RouteObject[] = [
  {
    path: 'snapshot',
    element: (
      <Suspense fallback={null}>
        <Snapshot />
      </Suspense>
    )
  }
];

export default DEBUG_ROUTES;
